import { actionable } from '@github/catalyst/lib/actionable'

export default actionable(class extends HTMLElement {
  connectedCallback () {
    this.elementIds = JSON.parse(this.dataset.elementIds)
    this.synchronizeControls = this.dataset.synchronizeControls
    this.usePageHash = this.dataset.usePageHash === 'true'
    this.viewIdPrefix = this.dataset.viewIdPrefix
    this.useComplexHash = this.dataset.useComplexHash === 'true'

    const urlHash = window.location.hash.slice(1)
    const elementId = this.useComplexHash ? urlHash.split('.')[0] : urlHash

    if (this.usePageHash && this.elementIds.includes(elementId)) {
      document.querySelectorAll(`[value="${elementId}"]`).forEach((element) => {
        element.click()

        if (this.useComplexHash) {
          history.pushState({}, '', `#${urlHash}`)
        }
      })
    }
  }

  trigger (event) {
    this.elementIds.forEach((elementId) => {
      const viewId = this.viewIdPrefix ? `${this.viewIdPrefix}-${elementId}` : elementId

      document.querySelectorAll(`#${viewId}`).forEach((element) => {
        element.classList.toggle('hidden', event.target.value !== elementId)
      })
    })

    if (this.synchronizeControls) {
      document.querySelectorAll(`[value="${event.target.value}"]`).forEach((element) => {
        element.checked = event.target.checked
      })
    }

    if (this.usePageHash && window.history && history.replaceState) {
      const url = new URL(window.location.href)
      url.hash = `#${event.target.value}`
      window.history.replaceState({}, '', url)
    }
  }
})
